export default "__VITE_ASSET__Q08xTznG__"